import {
    BuildEvents,
    DeviceEvents,
    EventReport,
    FileEvents,
    GroupEvents,
    LicenseEvents,
    ProductEvents,
    ProvisioningEvents,
    SubscriptionEvents,
    WorkspaceEvents,
} from "@dashboard/devices/types";
import { Theme } from "@mui/material";

import type { EventContentResult, EventContext } from "./shared/eventTypes";
import { renderBuildEventContent } from "./build";
import { renderDeviceEventContent } from "./device";
import { renderFileEventContent } from "./file";
import { renderGroupEventContent } from "./group";
import { renderLicenseEventContent } from "./license";
import { renderProductEventContent } from "./product";
import { renderProvisioningEventContent } from "./provisioning";
import { renderSubscriptionEventContent } from "./subscription";
import { renderUnknownEventContent } from "./unknown";
import { renderWorkspaceEventContent } from "./workspace";

export const renderEventContent = (event: EventReport, context: EventContext, theme: Theme): EventContentResult => {
    if (event.eventTypeName.startsWith("LicenseEvent.")) {
        const result = renderLicenseEventContent(event as LicenseEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("DeviceEvent.")) {
        const result = renderDeviceEventContent(event as DeviceEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("GroupEvent.")) {
        const result = renderGroupEventContent(event as GroupEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("SubscriptionEvent.")) {
        const result = renderSubscriptionEventContent(event as SubscriptionEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("BuildEvent.")) {
        const result = renderBuildEventContent(event as BuildEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("FileEvent.")) {
        const result = renderFileEventContent(event as FileEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("ProductEvent.")) {
        const result = renderProductEventContent(event as ProductEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("ProvisioningEvent.")) {
        const result = renderProvisioningEventContent(event as ProvisioningEvents, context, theme);
        if (result) {
            return result;
        }
    } else if (event.eventTypeName.startsWith("WorkspaceEvent.")) {
        const result = renderWorkspaceEventContent(event as WorkspaceEvents, context, theme);
        if (result) {
            return result;
        }
    }

    return renderUnknownEventContent({ event, context, theme });
};

export type { EventContentResult } from "./shared/eventTypes";
